import gal1 from '../assets/gal/gal1.jpg';
import gal2 from '../assets/gal/gal2.jpg';
import gal3 from '../assets/gal/gal3.jpg';
import gal4 from '../assets/gal/gal4.jpg';
import gal5 from '../assets/gal/gal5.jpg';
import gal6 from '../assets/gal/gal6.jpg';
import gal7 from '../assets/gal/gal7.jpg';
import gal8 from '../assets/gal/gal8.jpg';
import gal9 from '../assets/gal/gal9.jpg';
import gal10 from '../assets/gal/gal10.jpg';
import gal11 from '../assets/gal/gal11.jpg';
import gal12 from '../assets/gal/gal12.jpg';
import gal13 from '../assets/gal/gal13.jpg';
import gal14 from '../assets/gal/gal14.jpg';
import gal15 from '../assets/gal/gal15.jpg';
import gal16 from '../assets/gal/gal16.jpg';
import gal17 from '../assets/gal/gal17.jpg';
import gal18 from '../assets/gal/gal18.jpg';
import gal19 from '../assets/gal/gal19.jpg';
import bg from '../assets/bg.png';
import spoon from '../assets/spoon.png';
import kinfe from '../assets/knife.png';
import G from '../assets/G.png';
// import blog1 from '../assets/blog1.jpg';
// import blog2 from '../assets/blog2.jpg';
import fb from '../assets/facebook-logo.svg';
import intsa from '../assets/instagram-logo.svg';
import tiktok from '../assets/tiktok-logo.svg';

const images = {
  gal1,
  gal2,
  gal3,
  gal4,
  gal5,
  gal6,
  gal7,
  gal8,
  gal9,
  gal10,
  gal11,
  gal12,
  gal13,
  gal14,
  gal15,
  gal16,
  gal17,
  gal18,
  gal19,
  bg,
  kinfe,
  spoon,
  G,
  // blog2,
  // blog1,
  tiktok,
  intsa,
  fb
};

export default images;
